module.exports = __webpack_public_path__ + "static/media/mac-render-fallback.eecbb475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/mac-render-fallback.png
// module id = 1503
// module chunks = 0